import {LitElement, html, css, svg} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement('obi-chart-unknown')
export class ObiChartUnknown extends LitElement {
  @property({type: Boolean}) useCssColor = false;

  private icon = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M9.82183 16.1773V15.8709C9.82776 14.8193 9.91982 13.9811 10.098 13.3562C10.2821 12.7313 10.5494 12.2265 10.8998 11.842C11.2502 11.4574 11.6719 11.1089 12.1648 10.7964C12.533 10.5561 12.8627 10.3067 13.1537 10.0483C13.4447 9.78997 13.6763 9.50455 13.8486 9.19209C14.0208 8.87362 14.1069 8.5191 14.1069 8.12853C14.1069 7.71392 14.0089 7.35039 13.8129 7.03793C13.6169 6.72547 13.3526 6.48512 13.02 6.31687C12.6934 6.14862 12.3311 6.0645 11.9332 6.0645C11.5471 6.0645 11.1819 6.15163 10.8374 6.32588C10.4929 6.49413 10.2108 6.7465 9.99109 7.08299C9.77134 7.41348 9.65256 7.82508 9.63474 8.31781H6C6.0297 7.11604 6.31477 6.12459 6.85523 5.34344C7.39569 4.55629 8.11136 3.97042 9.00223 3.58586C9.8931 3.19529 10.876 3 11.951 3C13.1329 3 14.1782 3.19829 15.0869 3.59487C15.9955 3.98545 16.7082 4.55328 17.2249 5.29837C17.7416 6.04347 18 6.94179 18 7.99333C18 8.69636 17.8842 9.32128 17.6526 9.86808C17.4269 10.4089 17.1091 10.8896 16.6993 11.3102C16.2895 11.7248 15.8055 12.1004 15.2472 12.4369C14.778 12.7193 14.392 13.0137 14.0891 13.3201C13.7921 13.6266 13.5694 13.9811 13.4209 14.3837C13.2784 14.7863 13.2042 15.282 13.1982 15.8709V16.1773H9.82183Z" fill="currentColor"/>
<path d="M9.82183 17.6719H13.188V21H9.82183V17.6719Z" fill="currentColor"/>
</svg>
`;

  private iconCss = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.82183 16.1773V15.8709C9.82776 14.8193 9.91982 13.9811 10.098 13.3562C10.2821 12.7313 10.5494 12.2265 10.8998 11.842C11.2502 11.4574 11.6719 11.1089 12.1648 10.7964C12.533 10.5561 12.8627 10.3067 13.1537 10.0483C13.4447 9.78997 13.6763 9.50455 13.8486 9.19209C14.0208 8.87362 14.1069 8.5191 14.1069 8.12853C14.1069 7.71392 14.0089 7.35039 13.8129 7.03793C13.6169 6.72547 13.3526 6.48512 13.02 6.31687C12.6934 6.14862 12.3311 6.0645 11.9332 6.0645C11.5471 6.0645 11.1819 6.15163 10.8374 6.32588C10.4929 6.49413 10.2108 6.7465 9.99109 7.08299C9.77134 7.41348 9.65256 7.82508 9.63474 8.31781H6C6.0297 7.11604 6.31477 6.12459 6.85523 5.34344C7.39569 4.55629 8.11136 3.97042 9.00223 3.58586C9.8931 3.19529 10.876 3 11.951 3C13.1329 3 14.1782 3.19829 15.0869 3.59487C15.9955 3.98545 16.7082 4.55328 17.2249 5.29837C17.7416 6.04347 18 6.94179 18 7.99333C18 8.69636 17.8842 9.32128 17.6526 9.86808C17.4269 10.4089 17.1091 10.8896 16.6993 11.3102C16.2895 11.7248 15.8055 12.1004 15.2472 12.4369C14.778 12.7193 14.392 13.0137 14.0891 13.3201C13.7921 13.6266 13.5694 13.9811 13.4209 14.3837C13.2784 14.7863 13.2042 15.282 13.1982 15.8709V16.1773H9.82183Z" style="fill: var(--element-active-color)"/>
<path d="M9.82183 17.6719H13.188V21H9.82183V17.6719Z" style="fill: var(--element-active-color)"/>
</svg>
`;

  override render() {
    return html`
      <div class="wrapper">${this.useCssColor ? this.iconCss : this.icon}</div>
    `;
  }

  static override styles = css`
    .wrapper {
      height: 100%;
      width: 100%;
      line-height: 0;
    }
    .wrapper > * {
      height: 100%;
      width: 100%;
    }
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'obi-chart-unknown': ObiChartUnknown;
  }
}
